const modules = [...document.querySelectorAll('script[data-cm-module]')].map((node) => ({
  url: node.dataset.cmModule,
  selector: node.dataset.cmSelector,
  observed: new WeakSet(),
  pending: null,
}));

const start = (entry) => {
  if (entry.pending) return entry.pending;
  entry.pending = import(entry.url).catch((error) => {
    entry.pending = null;
    console.warn('Cantemiri: component could not load.', error);
  });
  return entry.pending;
};

const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;
    for (const module of modules) {
      if (entry.target.matches(module.selector)) start(module);
    }
    observer.unobserve(entry.target);
  }
}, { rootMargin: '300px 0px' });

const scan = (root) => {
  for (const module of modules) {
    if (module.pending) continue;
    const targets = [...root.querySelectorAll(module.selector)];
    if (root instanceof Element && root.matches(module.selector)) targets.push(root);
    for (const target of targets) {
      if (module.observed.has(target)) continue;
      module.observed.add(target);
      observer.observe(target);
    }
  }
};

scan(document);
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) scan(node);
    }
  }
}).observe(document.body, { childList: true, subtree: true });

for (const eventName of ['pointerover', 'focusin']) {
  document.addEventListener(eventName, (event) => {
    if (!(event.target instanceof Element)) return;
    for (const module of modules) {
      if (!module.pending && event.target.closest(module.selector)) start(module);
    }
  }, { passive: true });
}
